var createIsAsyncValidating = function createIsAsyncValidating(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.asyncValidating');
    };
  };
};

export default createIsAsyncValidating;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/selectors/isAsyncValidating.js
// module id = 680
// module chunks = 1